import './hero.scss';
import './import/cash-in-out.svg';
import './import/credit.svg';
import './import/insurance.svg';
import './import/pay-now-later.svg';
import './import/send-money.svg';
import './import/spending-limit.svg';
import './import/atm.svg';
import './import/iute-branch.svg';
import './import/wallet.svg';
import './import/partner.svg';
import './import/contact.svg';
import './import/icons_Add_Money.svg';
import './import/icons_Add-Receive_Money.svg';
import './import/icons_Application_Channel-Branch.svg';
import './import/icons_Application_Channel-Myiute.svg';
import './import/icons_Application_Channel-Partner.svg';
import './import/icons_Application_Channel-Website_2.svg';
import './import/icons_Application_Channel-Website.svg';
import './import/icons_Application_Channel–Call_Center.svg';
import './import/icons_Application_Channel–eCom.svg';
import './import/icons_Cash_Loan.svg';
import './import/icons_Digital_wallet.svg';
import './import/icons_Insurance-Accident.svg';
import './import/icons_Insurance-Car.svg';
import './import/icons_Insurance-Credit.svg';
import './import/icons_Insurance-Generic.svg';
import './import/icons_Insurance–Auto-Decision.svg';
import './import/icons_Locations-Partners.svg';
import './import/icons_Locations–ATM.svg';
import './import/icons_Locations–Branch_Offices.svg';
import './import/icons_P2P-Generic.svg';
import './import/icons_P2P-MoneyIN.svg';
import './import/icons_P2P-MoneyOUT.svg';
import './import/icons_Pay_Later-Dealer_Loan.svg';
import './import/icons_Pay_Now_with_IUTE.svg';
import './import/icons_Pay_Now.svg';
import './import/icons_QR_code.svg';
import './import/icons_Receive_Money.svg';
import './import/icons_Spending_Limit_Starter.svg';
import './import/icons_Spending_Limit.svg';
import './import/icons_Utilities–Electricity.svg';
import './import/icons_Utilities–Generic.svg';
import './import/icons_Utilities–Internet.svg';
import './import/icons_Utilities–TV.svg';
import './import/icons_Utilities–Water.svg';
